import React from "react";
import LgvSelectField from "../../../components/LgvSelectField";
import { QuestionItem } from "../../../types/form";
import { normalizeQuestionSelectOptions } from "../../../utils/selectOptions";

interface SelectFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  readOnly?: boolean;
}

const SelectFieldRenderer: React.FC<SelectFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  setFormData,
  readOnly = false,
}) => {
  const options = normalizeQuestionSelectOptions(question.options);

  return (
    <LgvSelectField
      id={inputName}
      name={inputName}
      value={String(currentValue ?? "")}
      options={options}
      disabled={readOnly}
      required={question.isRequired}
      placeholder={question.placeholder || "Select..."}
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          [inputName]: value,
        }))
      }
    />
  );
};

export default SelectFieldRenderer;
